export const contactPreviewTranslation = {
  header: {
    title: 'cng-contact_preview-header-title',
    subtitle: 'cng-contact_preview-header-subtitle',
    contactId: 'cng-contact_preview-header-contact_id',
    email: 'cng-contact_preview-header-email',
    contactName: 'cng-contact_preview-header-contact_name',
  },
  sideMenu: {
    basic: 'cng-contact_preview-side_menu-basic',
    additional: 'cng-contact_preview-side_menu-additional',
    userRights: 'cng-contact_preview-side_menu-user_rights',
    campaigns: 'cng-contact_preview-side_menu-campaigns',
    toolAccess: 'cng-contact_preview-side_menu-tool_access',
  },
}
